import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { StrategyService } from '../services/strategy.service';
import { forkJoin, Observable, switchMap } from 'rxjs';

export const tasksResolver: ResolveFn<Observable<any>> = (route, state) => {
  var strategyService = inject(StrategyService);
  return forkJoin(
    {
      strategies: strategyService.RawStrategies$,
      tasks: strategyService.defaultStrategy$.pipe(switchMap((x: any) => strategyService.GetTasks(x.id)))
    }
  )
};
